export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE';
export const GOOGLE_LOGIN_REQUEST = 'GOOGLE_LOGIN_REQUEST';
export const GOOGLE_LOGIN_REQUEST_SUCCESS = 'GOOGLE_LOGIN_REQUEST_SUCCESS';
export const GOOGLE_LOGIN_REQUEST_FAILURE = 'GOOGLE_LOGIN_REQUEST_FAILURE';
export const MFA_SETUP_REQUEST = 'MFA_SETUP_REQUEST';
export const MFA_SETUP_REQUEST_SUCCESS = 'MFA_SETUP_REQUEST_SUCCESS';
export const MFA_SETUP_REQUEST_FAILURE = 'MFA_SETUP_REQUEST_FAILURE';
export const MFA_VERIFY_REQUEST = 'MFA_VERIFY_REQUEST';
export const MFA_VERIFY_REQUEST_SUCCESS = 'MFA_VERIFY_REQUEST_SUCCESS';
export const MFA_VERIFY_REQUEST_FAILURE = 'MFA_VERIFY_REQUEST_FAILURE';
export const MFA_SETUP_VERIFY_REQUEST = 'MFA_SETUP_VERIFY_REQUEST';
export const MFA_SETUP_VERIFY_REQUEST_SUCCESS = 'MFA_SETUP_VERIFY_REQUEST_SUCCESS';
export const MFA_SETUP_VERIFY_REQUEST_FAILURE = 'MFA_SETUP_VERIFY_REQUEST_FAILURE';
export const REMOVE_TOKENS = 'REMOVE_TOKENS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_REQUEST_FAILURE = 'LOGOUT_REQUEST_FAILURE';
export const RESET_MFA_STATE = 'RESET_MFA_STATE';
export const SHOW_ADD_MFA_MODAL = 'SHOW_ADD_MFA_MODAL';
export const FORGOT_MFA = 'FORGOT_MFA';
export const FORGOT_MFA_SUCCESS = 'FORGOT_MFA_SUCCESS';
export const FORGOT_MFA_FAILURE = 'FORGOT_MFA_FAILURE';